import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Header/HeaderTrendingTopics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Header/MainHeaderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/BottomNavigator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyPrevention"] */ "/app/src/components/shared/CopyPrevention.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/ScrollToTop.tsx");
